<template>
  <div class="buy-exc-new container-fluid" v-if="bannerPlaceHolderForNewExclusiveRevamp">
    <div class="exc-title-div-new">
      <span class="exclusiveTitleNew">BECOME A MEMBER</span>
    </div>
    <div class="container-fluid">
      <div class="row" style="justify-content: center">
        <div class="col-sm-12 col-sm-6 col-lg-12" v-if="!dynamicExclusiveCards">
          <mainExclusiveCards :isDesktop="isDesktop" :addExclusiveMem="addMembershipToCart" :title_content="title_content"
            :popular_head="popular_head" :card_inactive="card_inactive" :card_active="card_active"
            :add_to_cart_btn="add_to_cart_btn_new" page="exclusive"></mainExclusiveCards>
        </div>
         <div class="col-sm-12 col-sm-6 col-lg-12" v-if="dynamicExclusiveCards">
          <mainExcDynamicCardsVue :isDesktop="isDesktop" :addExclusiveMem="addMembershipToCart" :title_content="title_content"
            :popular_head="popular_head" :card_inactive="card_inactive" :card_active="card_active"
            :add_to_cart_btn="add_to_cart_btn_new" page="exclusive"></mainExcDynamicCardsVue>
        </div>
      </div>
    </div>
  </div>
  <div v-else class="buy-exc container-fluid" id="buy-exc-membership">
    <div class="exc-title-div">
      <h2 class="exclusiveTitle">BECOME A MEMBER</h2>
    </div>
    <div class="container-fluid">
      <div class="row" style="justify-content: center">
        <div class="col-sm-12 col-sm-6 col-lg-6">
          <mainExclusiveCards :addExclusiveMem="addMembershipToCart" :title_content="title_content"
            :popular_head="popular_head" :card_inactive="card_inactive" :card_active="card_active"
            :add_to_cart_btn="add_to_cart_btn" page="exclusive"></mainExclusiveCards>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  var $ = require('jquery')
  window.jQuery = $
  import mainExclusiveCards from './mainExcCards.vue'
  import mainExcDynamicCardsVue from './mainExcDynamicCards.vue'
  import {mapGetters} from 'vuex'

  export default {
    props: ['addMembershipToCart', 'isDesktop'],
    data: function () {
      return {
        isDesktopExclusive: '',
        hideExclusiveCard: false
      }
    },
    components: {mainExclusiveCards, mainExcDynamicCardsVue},
    computed: {
      ...mapGetters(['bannerPlcaeHolderData']),
      title_content () {
        return 'color: #E66A51'
      },
      popular_head () {
        return {'text-transform': 'uppercase', 'border-radius': '9px 9px 0px 0px'}
      },
      card_inactive () {
        return {'border': '2px #a9aaa9 solid', 'border-radius': '10px', 'margin': '0px 5px', 'height': '250px'}
      },
      card_active () {
        return {'margin': '0px 5px', 'height': '250px', 'border-radius': '10px'}
      },
      add_to_cart_btn () {
        return {'color': '#ffffff', 'border-radius': '5px', 'margin-top': '60px', 'background-color': '#1a1f29', 'border-color': '#1a1f29', 'width': '50%', 'text-transform': 'uppercase'}
      },
      add_to_cart_btn_new () {
        return {'color': '#ffffff', 'border-radius': '5px', 'height': '50px', 'margin-top': '60px', 'background': 'linear-gradient(to bottom, #ff9d8a, #e76a52)', 'border-color': '#e76a52', 'width': '43.5%', 'text-transform': 'uppercase'}
      },
      bannerPlaceHolderForNewExclusiveRevamp: function () {
        const isExclusiveRevampObj = this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
          bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'EXCLUSIVE_REVAMP_NEW'.toLowerCase())
        if (isExclusiveRevampObj) {
          return true
        }
        return null
      },
      dynamicExclusiveCards () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
        bannerData.placeholder_for.toLowerCase() === 'Exclusive'.toLowerCase() && bannerData.status === true && bannerData.product_type === 'DYNAMIC_EXCLUSIVE_CARD')
      }
    },
    methods: {
      checkingMobile () {
        var b = $(window).width()
        if (b < 991) {
          this.isDesktopExclusive = false
        } else {
          this.isDesktopExclusive = true
        }
      },
      shouldhideExclusiveCard: function () {
        const currentTime = new Date()

        // console.log('start', new Date() - new Date('2019-12-18 00:00'))
        // console.log('end', new Date() - new Date('2019-12-18 23:59'))
        if (currentTime - new Date('2019-12-20 00:00') > 0 && currentTime - new Date('2019-12-20 23:59') < 0) {
          this.hideExclusiveCard = true
        }
      }
    },
    created () {
      this.checkingMobile()
      this.shouldhideExclusiveCard()
    }
  }
</script>

<style scoped>

  button {
    width: 85%;
    margin: 20px auto 10px;
  }

  .buy-exc {
    padding: 50px 0px 40px 0px;
    background-color: #f2f2f2; 
  }
  .buy-exc-new {
    padding: 20px 0px 20px 0px;
    background-color: #f2f2f2; 
  }
  .exclusiveTitle {
    color: #e76a52;
    font-weight: bold;
    font-size: 45px;
    letter-spacing: 2px;
  }
  .exclusiveTitleNew {
    color: #161b24;
    font-weight: bold;
    font-size: 26px;
    letter-spacing: normal;
  }
  .exc-title-div {
    margin-bottom: 50px;
  }
  .exc-title-div-new {
    margin-bottom: 25px;
  }

  @media screen and (max-width: 992px) {
    h1 {
      margin: 0;
      font-size: 1.5em;
    }

    .mobileFont {
      font-size: 1.5em;
    }
  }

  @media screen and (max-width: 768px) {
    .exclusiveTitle {
      font-size: 22px;
    }

    .buy-exc {
      padding: 25px 0px 40px 0px;
    }

    .exc-title-div {
      margin-bottom: 25px;
    }
  }

  @media (max-width: 576px) {
    .exclusiveTitle {
      font-size: 18px;
    }
    .exc-title-div {
      margin-bottom: 20px;
    }
    .exclusiveTitleNew {
      font-size: 1rem;
      letter-spacing: normal;
    }
    .buy-exc-new {
      padding: 20px 0px 20px 0px;
      background-color: #fff; 
    }
    .exc-title-div-new {
      margin-bottom: 8px;
    }
  }

</style>



// WEBPACK FOOTER //
// ExclusiveCard.vue?84eea0fe